export default defineNuxtPlugin({
  name: 'openfeature',
  dependsOn: ['user-segment'],
  setup: async (nuxtApp) => {
    const { loaded, client } = await useOpenFeature()
    nuxtApp.provide('openfeatureLoaded', loaded)
    nuxtApp.provide('openfeature', client)
  },
})
